// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".invalid-feedback[data-v-46e50a50] {\n  display: block;\n}", "",{"version":3,"sources":["webpack://./resources/components/selector/MessageElementsSelector.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB","sourcesContent":[".invalid-feedback[data-v-46e50a50] {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
